<!--
 * @Description:销量目标 
 * @Autor: txp
 * @Date: 2021-04-07 11:14:37
-->
<template>
    <div class="groupSalesTarget">
        <div class="title">{{names}}</div>
        <div class="content">
            <el-table 
            fixed border :data="tableData" 
            :header-cell-style="{ textAlign: 'center',fontSize:'13px',color:'#787878',background:'#F5F5F5'}"
            :cell-style="{textAlign:'center',fontSize:'14px',color:'#1D1D1D'}"
            >
                <el-table-column v-for="(item,index) in columns" :key="index" :prop="item.field" :label="item.title"></el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
import {mdmtableconfigForm} from '@/api/api'
export default {
    name:'groupSalesTarget',
    data(){
        return{
            tableData:[],
            columns:[
                {
                    title:'年度',
                    field:'targetYear'
                },
                {
                    title:'年总量',
                    field:'targetNum'
                }
            ]
        }
    },
    props:{
        dataLists:{
            type:Array
        },
        names:{
            type:String,
            default:"暂无"
        }
    },
    created(){
        this.getTaskConfig()
        this.getTypeConfig()
        this.repeatData()
    },
    methods:{
        /**
         * @description: 通过tasktype获取对应的类型
         * @param {*}  functionCode 类型
         * @return {*}
         * @author: txp
         */
        getTaskConfig(){
            let functionCode = ''
            const taskType = this.dataLists[0] ? `${this.dataLists[0].taskType}`: '1'
            switch (taskType) {
                case '1': functionCode = 'target_table_year'; break;
                case '2': functionCode = 'target_table_quarter'; break;
                case '3': functionCode = 'target_table_month'; break;
                default:
                break;
            }
            mdmtableconfigForm({
                functionCode,
                parentCode: 'CRM20210203000000866'
            }).then(res=>{

                 const rightColumns = [] 
                 res.result.forEach(v => {
                    rightColumns.push({
                        title: v.title,
                        field: v.field,
                    })
                })
                this.columns = this.columns.concat(rightColumns)
            }).catch(error=>{
                this.$message.error(error)
            })
        },
        /**
         * @description:
         * @param {*}
         * @return {*}
         * @author: txp
         */
        repeatData(){
            const list = []
            this.dataLists.forEach(v=>{
                list.push({
                ...v,
                ...v.saleGoalItemVo
                })
            })
            this.tableData = list
        },
        /**
         * @description: 通过type获取具体参数值
         * @param {*}
         * @return {*}
         * @author: txp
         */
        getTypeConfig(){
            let functionCode = 'target_table_' + (this.dataLists[0].type)
            mdmtableconfigForm({
                functionCode,
                parentCode: 'CRM20210203000000866'
            }).then(res=>{
                let leftColumns = []
                res.result.forEach(v => {
                    switch (v.field) {
                        case 'productName': v.field = 'goodsName';break;
                        case 'productCode': v.field = 'goodsCode';break;
                        default:
                        break;
                    }
                    leftColumns.push({
                        title: v.title,
                        field: v.field,
                    })
                })
                this.columns = leftColumns.concat(this.columns)
            }).catch(error=>{
                this.$message.error(error)
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    .groupSalesTarget{
        margin: 20px 0px;
        border-bottom: 1px solid $color-primary;
        .title{
            font-size: 18px;
            font-weight: 600;
            border-left: 9px solid $color-primary;
            padding-left: 9px;
            margin-bottom: 20px;
            height: 18px;
            line-height: 18px;
        }
        .content{
            padding: 20px;
        }
        // // 设置滚动条样式
        // /deep/ .el-table__body-wrapper::-webkit-scrollbar {
        //     width: 5px!important;
        // }
        // /deep/ .el-table__body-wrapper::-webkit-scrollbar-track{
        //     background-color: #fafafa;
        // }
        // /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
        //     // background: rgba(27, 140, 236, 0.5); //主题色添加
        //     background:$color-primary; 
        // }
    }
</style>